const TEMPORARY_EMAIL_DOMAINS = [
  "mailinator.com",
  "guerrillamail.com",
  "temp-mail.org",
  "yopmail.com",
  "10minutemail.com",
  "dispostable.com",
  "trashmail.com",
  "getnada.com",
]

const NON_BUISNESS_EMAIL_DOMAINS = [
  "adrewire.com",
  "temples.33mail.com",
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
]

const isTemporaryEmail = (email) => {
  return TEMPORARY_EMAIL_DOMAINS.some((domain) => email.endsWith(`@${domain}`))
}

const isNonBusinessEmail = (email) => {
  return NON_BUISNESS_EMAIL_DOMAINS.some((domain) => email.endsWith(`@${domain}`))
}

export { isTemporaryEmail, isNonBusinessEmail, TEMPORARY_EMAIL_DOMAINS, NON_BUISNESS_EMAIL_DOMAINS }
